<div fxLayout="column">
  <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
  <div *ngIf="isBrowserIE; else noteBalanceAdjustmentsListFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
    <ng-container *ngTemplateOutlet="noteBalanceAdjustmentsListFlexColumnTemplate"></ng-container>
  </div>
</div>

<ng-template #noteBalanceAdjustmentsListFlexColumnTemplate>
  <div fxLayout="column">
    <div class="display-text normal-paragraph-spacing" style="text-align: center" *ngIf="showSpinner">
      <mat-spinner color="accent" diameter="32"></mat-spinner>
    </div>
    <div fxLayout="column" *ngIf="!showSpinner">
      <div *ngIf="isBrowserIE; else noteBalanceAdjustmentsListTableFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
        <ng-container *ngTemplateOutlet="noteBalanceAdjustmentsListTableFlexColumnTemplate"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #noteBalanceAdjustmentsListTableFlexColumnTemplate>
  <div fxFlex="100%" class="display-text primary-dark-color-important">
    <b><span i18n="@@note-balance-adjustments-list.table.title">note-balance-adjustments-list.table.title</span></b>
  </div>

  <div fxFlex="100%" class="display-text title-spacer" *ngIf="!noteBalanceAdjustmentsListFound">
    <i><span i18n="@@note-balance-adjustments-list.table.no-records">note-balance-adjustments-list.table.no-records</span></i>
  </div>

  <div fxFlex="100%" [ngStyle]="{ display: tableDisplayStyle }">
    <mat-table #table [dataSource]="tableDataSource" class="primary-lightest-bg" ngClass.lt-md="small-table-text">
      <!-- adjustmentDate Column -->
      <ng-container matColumnDef="adjustmentDate">
        <mat-header-cell *matHeaderCellDef fxFlex="14%">
          <span
            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
            i18n="@@note-balance-adjustments-list.table.column-header.adjustment-date"
            >note-balance-adjustments-list.table.column-header.adjustment-date</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="14%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.adjustmentDate | date: 'MM/dd/yyyy'
        }}</mat-cell>
      </ng-container>
      <!-- adjustmentId Column -->
      <ng-container matColumnDef="adjustmentId">
        <mat-header-cell *matHeaderCellDef fxFlex="14%">
          <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }" i18n="@@note-balance-adjustments-list.table.column-header.adjustment-id"
            >note-balance-adjustments-list.table.column-header.adjustment-id</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="14%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.adjustmentId
        }}</mat-cell>
      </ng-container>
      <!-- transactionAmount Column -->
      <ng-container matColumnDef="transactionAmount">
        <mat-header-cell *matHeaderCellDef fxFlex="14%">
          <span
            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
            i18n="@@note-balance-adjustments-list.table.column-header.transaction-amount"
            >note-balance-adjustments-list.table.column-header.transaction-amount</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="14%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.transactionAmount | currency
        }}</mat-cell>
      </ng-container>
      <!-- principalAmount Column -->
      <ng-container matColumnDef="principalAmount">
        <mat-header-cell *matHeaderCellDef fxFlex="14%">
          <span
            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
            i18n="@@note-balance-adjustments-list.table.column-header.principal-amount"
            >note-balance-adjustments-list.table.column-header.principal-amount</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="14%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.principalAmount | currency
        }}</mat-cell>
      </ng-container>
      <!-- interestAmount Column -->
      <ng-container matColumnDef="interestAmount">
        <mat-header-cell *matHeaderCellDef fxFlex="14%">
          <span
            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
            i18n="@@note-balance-adjustments-list.table.column-header.interest-amount"
            >note-balance-adjustments-list.table.column-header.interest-amount</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="14%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.interestAmount | currency
        }}</mat-cell>
      </ng-container>
      <!-- feeAmount Column -->
      <ng-container matColumnDef="feeAmount">
        <mat-header-cell *matHeaderCellDef fxFlex="14%">
          <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }" i18n="@@note-balance-adjustments-list.table.column-header.fee-amount"
            >note-balance-adjustments-list.table.column-header.fee-amount</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="14%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.feeAmount | currency
        }}</mat-cell>
      </ng-container>
      <!-- adjustmentDescription Column -->
      <ng-container matColumnDef="adjustmentDescription">
        <mat-header-cell *matHeaderCellDef fxFlex="16%">
          <span
            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
            i18n="@@note-balance-adjustments-list.table.column-header.adjustment-description"
            >note-balance-adjustments-list.table.column-header.adjustment-description</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="16%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.adjustmentDescription
        }}</mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="tableDisplayedColumns" ngClass.lt-md="small-header-row"></mat-header-row>
      <mat-row *matRowDef="let row; columns: tableDisplayedColumns" ngClass.lt-md="small-row"></mat-row>
    </mat-table>
  </div>
  <div fxFlex="100%" fxLayoutAlign="end center" class="small-display-text primary-light-color" *ngIf="noteBalanceAdjustmentsListFound">
    <app-table-record-count
      [recordCount]="noteBalanceAdjustmentsList.length"
      i18n-singularLabel="@@note-balance-adjustments-list.table.record-count.singular-label"
      singularLabel="note-balance-adjustments-list.table.record-count.singular-label"
      i18n-multipleLabel="@@note-balance-adjustments-list.table.record-count.multiple-label"
      multipleLabel="note-balance-adjustments-list.table.record-count.multiple-label"
    ></app-table-record-count>
  </div>
</ng-template>
